// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__Gluy0","paragraph":"Terms_paragraph__N2jKM","numberedList":"Terms_numberedList__CjBjD"};